import { Languages } from "waapi/front-utils/hooks/useTranslation/types.js";
import DutchFlag from "../../../assets/dutchFlag.svg?react";
import EnglishFlag from "../../../assets/englishFlag.svg?react";
import FrenchFlag from "../../../assets/frenchFlag.svg?react";
import GermanFlag from "../../../assets/germanFlag.svg?react";
import IndonesiaFlag from "../../../assets/indonesiaFlag.svg?react";
import ItalyFlag from "../../../assets/italyFlag.svg?react";
import PolandFlag from "../../../assets/polandFlag.svg?react";
import PortugalFlag from "../../../assets/portugalFlag.svg?react";
import RussianFlag from "../../../assets/russianFlag.svg?react";
import SpainFlag from "../../../assets/spainFlag.svg?react";

export const flagMatch: Record<Languages, JSX.Element> = {
    [Languages.EN]: <EnglishFlag />,
    [Languages.FR]: <FrenchFlag />,
    [Languages.ES]: <SpainFlag />,
    [Languages.RU]: <RussianFlag />,
    [Languages.DE]: <GermanFlag />,
    [Languages.PT]: <PortugalFlag />,
    [Languages.IT]: <ItalyFlag />,
    [Languages.NL]: <DutchFlag />,
    [Languages.PL]: <PolandFlag />,
    [Languages.ID]: <IndonesiaFlag />,
};

export const extendedLabel: Record<Languages, string> = {
    [Languages.EN]: "English",
    [Languages.FR]: "Français",
    [Languages.ES]: "Español",
    [Languages.RU]: "Русский",
    [Languages.DE]: "Deutsch",
    [Languages.PT]: "Português",
    [Languages.IT]: "Italiano",
    [Languages.NL]: "Nederlands",
    [Languages.PL]: "Polski",
    [Languages.ID]: "Indonesia",
};
